import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) {}

  createFormData(purchaseOrder: any): FormData {
    //// debugger
    if (purchaseOrder.transactionDate && typeof purchaseOrder.transactionDate !== 'string') {
        purchaseOrder.transactionDate = (new Date(purchaseOrder.transactionDate)).toISOString();
    }
    const formData = new FormData();

    // Add id field
    formData.append('id', purchaseOrder.id?.toString() || '0');
  
    // Append main properties
    formData.append('customerId', purchaseOrder.customerId?.toString() || '');
    formData.append('factoryId', purchaseOrder.factoryId?.toString() || '');
    formData.append('salesManId', purchaseOrder.salesManId?.toString() || '');
    formData.append('status', purchaseOrder.status?.toString() || '');
    formData.append('transactionDate', purchaseOrder.transactionDate || '');
    formData.append('total', purchaseOrder.total?.toString() || '0');
    formData.append('totalBeforeVAT', purchaseOrder.totalBeforeVAT?.toString() || '0');
    formData.append('vatAmount', purchaseOrder.vatAmount?.toString() || '0');
    formData.append('vatPercentage', purchaseOrder.vatPercentage?.toString() || '0');
    formData.append('notes', purchaseOrder.notes?.toString() || '');

    //formData.append('parentpuchaseOrderId', puchaseOrder.parentpuchaseOrderId?.toString() || '');
   // formData.append('customerAddressId', puchaseOrder.customerAddressId?.toString() || '');
  
    // Handle sales order lines
    if (purchaseOrder.purchaseOrderLines?.length > 0) {
        purchaseOrder.purchaseOrderLines.forEach((line, index) => {
        // Include line id for updates
        formData.append(`purchaseOrderLines[${index}].Id`, line.id?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].ItemId`, line.itemId?.toString() || '');
        formData.append(`purchaseOrderLines[${index}].Quantity`, line.quantity?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].Total`, line.total?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].TotalBeforeVAT`, line.totalBeforeVAT?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].UnitPrice`, line.unitPrice?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].UOM`, line.uom || '');
        formData.append(`purchaseOrderLines[${index}].VATAmount`, line.vatAmount?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].VATPercentage`, line.vatPercentage?.toString() || '0');
        formData.append(`purchaseOrderLines[${index}].customerAddressId`, line.customerAddressId?.toString() || '0');
       // formData.append(`puchaseOrderLines[${index}].customerAddress`, line.customerAddress?.toString() || '');

        // Add sales quotation reference fields if they exist
        if (line.salesQuotationId) {
          formData.append(`purchaseOrderLines[${index}].parentSalesQuotationId`, line.salesQuotationId?.toString() || '');
          formData.append(`purchaseOrderLines[${index}].ParentSalesQuotationLineId`, line.salesQuotationLineId?.toString() || '');
        }
      });
    }
      // Handle document attachments
  if (purchaseOrder.documentAttachments?.length > 0) {
    purchaseOrder.documentAttachments.forEach((attachment, index) => {
      // Include attachment id for updates
      formData.append(`DocumentAttachments[${index}].Id`, attachment.id?.toString() || '0');
      formData.append(`DocumentAttachments[${index}].Filename`, attachment.filename || '');
      // Only append file content if it's a new file (Blob/File object)
      if (attachment.fileContent instanceof Blob) {
        formData.append(`DocumentAttachments[${index}].FileContent`, attachment.fileContent);
      }
      // Include path for existing files
      if (attachment.path) {
        formData.append(`DocumentAttachments[${index}].Path`, attachment.path);
      }
    });
  }

  // Log FormData contents for debugging
  (formData as any).forEach((value: any, key: string) => {
   // console.log(`${key}: ${value}`);
  });


  return formData;
  }
  
  getAllPurchaseOrders() {
    return this.http.get<any>(`${this._baseUrl}/PurchaseOrder`);
  }

  getPaginatedPurchaseOrders(
    pageIndex = 0,
    pageSize = 10,
    pagination = false,
    criteria = null
  ) {
    return this.http.get<any>(
      `${this._baseUrl}/PurchaseOrder/paginated?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? '&criteria=' + criteria : ''}`
    );
  }

  getPurchaseOrderById(id: number) {
    return this.http.get<any>(`${this._baseUrl}/PurchaseOrder/${id}`);
  }

  deletePurchaseOrder(id: number) {
    return this.http.delete<any>(`${this._baseUrl}/PurchaseOrder/${id}`);
  }

  addNewPurchaseOrder(purchaseOrder: any) {
    // // debugger;
    const formData = this.createFormData(purchaseOrder);
    return this.http.post<any>(`${this._baseUrl}/PurchaseOrder/Add`, formData);
  }

  updatePurchaseOrder(id: number, puchaseOrder: any) {
    const formData = this.createFormData(puchaseOrder);
    return this.http.patch<any>(
      `${this._baseUrl}/PurchaseOrder/${id}`,
      formData
    );
  }
  getUnitPriceForCustomer(customerId: number, productId: number,customerAddressId:number) {
    const params = new HttpParams()
      .set('customer_id', customerId.toString())
      .set('product_id', productId.toString())
      .set('customerAddressId', customerAddressId.toString());
console.log(`${this._baseUrl}/PurchaseOrder/UnitPriceForCustomer`, { params });
    return this.http.get<any>(`${this._baseUrl}/PurchaseOrder/UnitPriceForCustomer`, { params });
  }
}